export const categories = [
    "Dashboard",
    "Profile",
    "Clubs",
    "Events",
    "My Golf",
    "Messages",
    "General",
    "Menu",
];

const flags = [
    // Dashboard
    {
        name: "Membership card",
        key: "MEMBERSHIP_CARD",
        category: "Dashboard",
        description: "The membership card on the dashboard",
    },
    {
        name: "Dashboard links",
        key: "DASHBOARD_LINKS",
        category: "Dashboard",
        description: "The list of links on the dashboard",
    },
    {
        name: "Travel concierge",
        key: "TRAVEL_CONCIERGE",
        category: "Dashboard",
        description:
            "The travel concierge section shown on the dashboard of the app",
    },
    // Profile
    {
        name: "Member directory",
        key: "MEMBER_DIRECTORY",
        category: "Profile",
        description:
            "The member directory containing all members across all entities who have chosen to appear on the list",
    },
    // Clubs
    {
        name: "Golf club reviews display",
        key: "GOLF_CLUB_REVIEWS_DISPLAY",
        category: "Clubs",
        description:
            "The stars and list of reviews shown on the list of clubs and each individual club",
    },
    {
        name: "Golf club reviews collection",
        key: "GOLF_CLUB_REVIEWS_COLLECTION",
        category: "Clubs",
        description:
            "Whether to show the review button or to contact members to request reviews following a booking",
    },
    // Events
    {
        name: "Event reviews collection",
        key: "EVENT_REVIEWS_COLLECTION",
        category: "Events",
        description:
            "Whether to contact members for event reviews after an event has taken place",
    },
    {
        name: "Event attendees",
        key: "EVENT_ATTENDEES",
        category: "Events",
        description: "Whether to show the attendees list on events",
    },
    //General
    {
        name: "Contact MASHIE",
        key: "CONTACT_MASHIE",
        category: "General",
        description: "Any links to the contact MASHIE page",
    },
    {
        name: "MASHIE clothing",
        key: "MASHIE_CLOTHING",
        category: "General",
        description: "The banner link through to MASHIE clothing",
    },
    {
        name: "Pin insurance banner",
        key: "PIN_INSURANCE_BANNER",
        category: "General",
        description:
            "The advertisement banner for Hiscox Pin insurance shown in various places throughout the app",
    },
    {
        name: "Trade Nation advert",
        key: "TRADE_NATION_ADVERT",
        category: "General",
        description:
            "The advertisement banner for Trade Nation shown in various places throughout the app",
    },
    {
        name: "Partner brands & member offers",
        key: "PARTNER_BRANDS_MEMBER_OFFERS",
        category: "General",
        description:
            "Any banner or menu item linking to the partner brands or member offers page",
    },
    {
        name: "Upgrade MASHIE Membership",
        key: "UPGRADE_MASHIE_MEMBERSHIP",
        category: "General",
        description:
            "Any banner or link that invites the user to upgrade their current MASHIE membership",
    },
    //Menu
    {
        name: "Help Centre Link",
        key: "HELP_CENTRE",
        category: "Menu",
        description: "Whether or not to show the Help Centre Link in the menu",
    },
    {
        name: "MASHIE social media links",
        key: "SOCIAL_LINKS",
        category: "Menu",
        description:
            "Whether or not to show links to MASHIE's social media pages in the menu",
    },
    {
        name: "App made by / general advert",
        key: "APP_ADVERT",
        category: "Menu",
        description:
            "Whether or not to show an advert (App powered by / made by / general ad) in the menu",
    },
];

export default flags;
